module.exports = __webpack_public_path__ + "static/media/galdinsLose_10000_25000.8c212de5.png";